import { CSSProperties, useEffect, useState } from 'react'
import { DataGridHeaderProps } from '../types'

function DataGridHeader ( props: DataGridHeaderProps ) {
    const { columnDefs, noRowNo } = props
    const [ colDefs ] = useState( !noRowNo ? [ { headerName: 'No.', field: 'rowNo', editable: false }, ...columnDefs ] : columnDefs )
    const getDataGridHeader = () => {
        return colDefs.filter( ( { field } ) => field )
            .map( ( { headerName, width = 50, type }, idx ) => {
                const style: CSSProperties = {
                    width,
                    margin: type === 'button' && '0 2px'
                }
                return (
                    <div
                        key={ `${ headerName }${ idx }` }
                        className="data-grid-header-cell"
                        style={ style }
                    >
                        <span>{ headerName }</span>
                    </div>
                )
            } )
    }

    return (
        <div className="data-grid-header-wrapper">
            <div className="data-grid-header-row flex">
                { getDataGridHeader() }
            </div>
        </div>
    )
}

export default DataGridHeader